export default {
      id: "ic_arrow_right_dark_gray-usage",
      viewBox: "0 0 10 10",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_right_dark_gray-usage",
      toString: function () {
        return this.url;
      }
    }